import { Check, Ban } from "lucide-react";
import { cn } from "@/lib/utils";
import { APPEARANCE_PALETTE } from "@/lib/appearancePalette";

// Curated palette swatches + a "default / none" reset. Accessible mid-tones only.
export function ColorSwatchPicker({ value, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="color-picker">
      <button type="button" onClick={() => onChange("")} title="Nirvana default" data-testid="color-none"
        className={cn("flex h-8 w-8 items-center justify-center rounded-full border-2 text-muted-foreground transition-transform hover:scale-105",
          !value ? "border-accent" : "border-border")}>
        <Ban className="h-3.5 w-3.5" />
      </button>
      {APPEARANCE_PALETTE.map((c) => (
        <button key={c.value} type="button" onClick={() => onChange(c.value)} title={c.name} data-testid={`color-opt-${c.name.toLowerCase()}`}
          style={{ backgroundColor: c.value }}
          className={cn("flex h-8 w-8 items-center justify-center rounded-full ring-2 ring-offset-2 ring-offset-background transition-transform hover:scale-105",
            value === c.value ? "ring-foreground/70" : "ring-transparent")}>
          {value === c.value && <Check className="h-4 w-4 text-white" />}
        </button>
      ))}
    </div>
  );
}
